import { THEME_CONFIG } from 'configs/AppConfig'
import { createSlice } from '@reduxjs/toolkit'

export const initialState = THEME_CONFIG

export const themeSlice = createSlice({
	initialState,
	name: 'theme',
	reducers: {
        onBlankLayout: (state, action) => {
			state.blankLayout = action.payload
		},
        onDirectionChange: (state, action) => {
			state.direction = action.payload
		},
        onHeaderNavColorChange: (state, action) => {
			state.headerNavColor = action.payload
		},
        onLocaleChange: (state, action) => {
			state.locale = action.payload
		},
        onMobileNavToggle: (state, action) => {
			state.mobileNav = action.payload
		},
        onNavStyleChange: (state, action) => {
			state.sideNavTheme = action.payload
		},
        onNavTypeChange: (state, action) => {
			state.navType = action.payload
		},
        onSwitchTheme: (state, action) => {
			state.currentTheme = action.payload
		},
        onTopNavColorChange: (state, action) => {
			state.topNavColor = action.payload
		},
		toggleCollapsedNav: (state, action) => {
			state.navCollapsed = action.payload
		},
	},
})

export const { 
    onBlankLayout,
    onDirectionChange,
    onHeaderNavColorChange,
    onLocaleChange,
    onMobileNavToggle,
    onNavStyleChange,
    onNavTypeChange,
    onSwitchTheme,
    onTopNavColorChange,
	toggleCollapsedNav
} = themeSlice.actions

export default themeSlice.reducer